export default __webpack_public_path__ + "static/guide-saas-6dc3f5542225f3aa11a36c61e8e073b8.svg";